import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BreadcrumbNav from '@/components/base/BreadcrumbNav';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16 md:pt-18">
        <BreadcrumbNav
          customPath={[
            { name: '首页', path: '/' },
            { name: '关于我们' },
          ]}
        />

        {/* Brand Intro */}
        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 mb-6">
                  <i className="ri-clapperboard-line text-4xl text-primary-500"></i>
                </div>
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
                  关于西瓜影院
                </h1>
                <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                  西瓜影院成立于2024年，致力于为广大影迷提供最优质的在线观影体验。我们相信，每个人都有权利享受高质量的影视内容，不应被付费墙所阻挡。
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12">
                {[
                  { num: '10万+', label: '影视资源' },
                  { num: '5000万+', label: '活跃用户' },
                  { num: '99.9%', label: '服务可用率' },
                  { num: '24/7', label: '内容更新' },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-6 rounded-xl bg-background-100 border border-background-200/60"
                  >
                    <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                      {stat.num}
                    </p>
                    <p className="text-xs text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>

              {/* Mission */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '安全可靠',
                    desc: '采用先进的加密技术，保护您的隐私安全，无病毒、无广告骚扰，纯净观影体验。',
                  },
                  {
                    icon: 'ri-flashlight-line',
                    title: '极速流畅',
                    desc: '全球CDN加速节点覆盖，智能选择最优线路，确保高清视频秒开不缓冲。',
                  },
                  {
                    icon: 'ri-heart-line',
                    title: '用户至上',
                    desc: '倾听每一位用户的反馈，持续优化产品体验，让观影成为一种享受。',
                  },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center"
                  >
                    <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-50 mb-4">
                      <i className={`${item.icon} text-2xl text-primary-500`}></i>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-800 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section id="reputation" className="py-12 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-500">
                  来自真实用户的评价
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {[
                  {
                    name: '王先生',
                    role: '影视爱好者',
                    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%20with%20soft%20natural%20lighting&width=120&height=120&seq=xgyy-avatar-1&orientation=squarish',
                    text: '西瓜影院真的是我发现的最好的免费观影平台！资源丰富，更新快，画质清晰，而且完全没有广告打扰。现在每天下班回家第一件事就是打开西瓜影院。',
                    rating: 5,
                  },
                  {
                    name: '李女士',
                    role: '全职妈妈',
                    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%20with%20soft%20natural%20lighting&width=120&height=120&seq=xgyy-avatar-2&orientation=squarish',
                    text: '带娃之余就靠西瓜影院打发时间了，电视剧追得停不下来。推荐给身边所有的朋友了，大家都说好用！少儿频道孩子也很喜欢，内容健康又有趣。',
                    rating: 5,
                  },
                  {
                    name: '张同学',
                    role: '大学生',
                    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20male%20student%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%20with%20soft%20natural%20lighting&width=120&height=120&seq=xgyy-avatar-3&orientation=squarish',
                    text: '作为一个追番党，西瓜影院的动漫频道真的太香了！更新速度和画质都很棒，还有很多经典老番可以重温。宿舍四个人都在用，强烈推荐！',
                    rating: 5,
                  },
                  {
                    name: '赵先生',
                    role: 'IT工程师',
                    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20man%20in%20glasses%2C%20tech%20professional%20look%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%20with%20soft%20natural%20lighting&width=120&height=120&seq=xgyy-avatar-4&orientation=squarish',
                    text: '作为技术人员，我很在意网站的流畅度和用户体验。西瓜影院的加载速度真的很快，界面简洁好用，播放器功能也很完善。技术和内容都在线！',
                    rating: 5,
                  },
                ].map((review, index) => (
                  <div
                    key={index}
                    className="p-6 rounded-xl bg-background-50 border border-background-200/60"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-sm font-medium text-foreground-800">
                          {review.name}
                        </p>
                        <p className="text-xs text-foreground-500">{review.role}</p>
                      </div>
                      <div className="ml-auto flex items-center gap-0.5">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      "{review.text}"
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="py-12 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500">
                  有任何问题或建议，欢迎随时联系我们
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Contact Info */}
                <div className="space-y-5">
                  {[
                    {
                      icon: 'ri-mail-line',
                      title: '电子邮箱',
                      content: 'contact@xiguayingyuan.com',
                    },
                    {
                      icon: 'ri-phone-line',
                      title: '客服电话',
                      content: '400-123-4567',
                    },
                    {
                      icon: 'ri-map-pin-line',
                      title: '公司地址',
                      content: '北京市朝阳区影视产业园区A座',
                    },
                    {
                      icon: 'ri-time-line',
                      title: '工作时间',
                      content: '周一至周日 9:00 - 22:00',
                    },
                  ].map((item) => (
                    <div key={item.title} className="flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-primary-50">
                        <i className={`${item.icon} text-lg text-primary-500`}></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800 mb-0.5">
                          {item.title}
                        </p>
                        <p className="text-sm text-foreground-500">{item.content}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Contact Form */}
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
                  <h3 className="text-lg font-heading font-bold text-foreground-800 mb-5">
                    发送消息
                  </h3>
                  <form
                    id="contact-form"
                    data-readdy-form
                    action="https://readdy.ai/api/form/d9mtbjsit35ii3jdllm0"
                    method="POST"
                    className="space-y-4"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const formData = new FormData(form);
                      const honeypotVal = (formData.get('phone_alt') as string || '').trim();
                      if (honeypotVal) {
                        alert('消息已发送，我们会尽快回复您！');
                        form.reset();
                        return;
                      }
                      formData.delete('phone_alt');
                      try {
                        const params = new URLSearchParams();
                        formData.forEach((value, key) => {
                          params.append(key, value as string);
                        });
                        const res = await fetch(form.getAttribute('action') || '', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: params.toString(),
                        });
                        const text = await res.text();
                        let parsed;
                        try { parsed = JSON.parse(text); } catch { parsed = null; }
                        if (res.ok && parsed?.code === 'OK') {
                          alert('消息已发送，我们会尽快回复您！');
                          form.reset();
                        } else {
                          const msg = parsed?.meta?.message || parsed?.message || text || '发送失败';
                          alert(msg.includes('spam') ? '发送失败，请稍后再试' : msg);
                        }
                      } catch {
                        alert('网络错误，请稍后再试');
                      }
                    }}
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名
                      </label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        邮箱
                      </label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200 resize-none"
                        placeholder="请输入您的留言内容（最多500字）"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="form-spam-field"
                    />
                    <button
                      type="submit"
                      className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '西瓜影院',
          url: 'https://www.xiguayingyuan.com/',
          description: '西瓜影院提供海量免费电影、电视剧、综艺在线观看。',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+86-400-123-4567',
            contactType: 'customer service',
            email: 'contact@xiguayingyuan.com',
            areaServed: 'CN',
            availableLanguage: 'Chinese',
          },
          address: {
            '@type': 'PostalAddress',
            streetAddress: '北京市朝阳区影视产业园区A座',
            addressLocality: '北京',
            addressCountry: 'CN',
          },
        })}
      </script>
    </>
  );
}